import { useQueryClient } from 'react-query';

import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { apiUrl } from 'src/core/utils/api';

import { type ExpenseCategory } from '../expenseCategory';

export const useBulkDeleteExpenseCategories = () => {
  const companyId = useCompanyId();
  const queryClient = useQueryClient();

  return async (expenseCategories: ExpenseCategory[]): Promise<void> => {
    const deletePromises = expenseCategories.map(async (expenseCategory) => {
      const response = await fetch(
        apiUrl(`/expense-categories/${expenseCategory.id}`, companyId),
        {
          method: 'DELETE',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      if (!response.ok) {
        throw new Error('Failed to delete expense category');
      }

      if (
        response.status === 204 ||
        response.headers.get('content-length') === '0'
      ) {
        return;
      }

      return response.json();
    });

    await Promise.all(deletePromises);

    await queryClient.invalidateQueries('expenseCategories');
  };
};
